<template>
	<ul class="breadcrumb">
		<li 
		v-for="(part, i) in parts"
		:class="{ 
			active: part.Ordem == selected,
			visited: part.Ordem != selected && part.RespondeuPart }"
		@click="changePart(part.Ordem)">{{ part.Ordem }}</li>
	</ul>
</template>

<script>
	import bus from '@/bus/event-bus.js'

	export default {
		props: ['parts', 'selected'],

		methods: {
			changePart(ordem) {
				this.$emit('changed', ordem)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/Breadcrumb.vue